import { cn } from "@choose/ui";
import { useTranslation } from "react-i18next";

import type { SupportTicketChannel } from "~/graphql/graphql.gen";
import { getTicketChannels } from "~/stores/ticket-channels-store";

export function TicketChannel({
  channel,
  className,
  variant = "default",
}: {
  channel: SupportTicketChannel;
  className?: string;
  variant?: "default" | "small";
}) {
  const { t } = useTranslation();

  const foundChannel = getTicketChannels(t).find((c) => c.value === channel);

  return (
    <span className={cn("flex shrink-0 items-center gap-1", className)}>
      <span className="text-muted-foreground [&>svg]:size-4">
        {foundChannel?.icon && <foundChannel.icon />}
      </span>
      {variant === "default" ? <span>{foundChannel?.label}</span> : null}
    </span>
  );
}
